<template>
  <div class="application">
    <el-container>
      <el-header height="80px" style="background-color: #f4f4f4; padding: 0px">
        <el-row>
          <el-col :span="8" style="height:80px;" class="alignVCenter">
            <i
                class="fa fa-home"
                style="font-size: 1.6em; color:#777; z-index: 11; cursor: pointer; padding: 0 1.195em"
                @click="onLogoClick()"
            ></i>
          </el-col>
          <el-row justify="end" type="flex">
            <div class="alignVHCenter" style="height:80px" :class="{ 'mr-3': !bShowShoppingCartIcon }">
              <UserDropDownIcon
                :isUserLoggedIn="userIsLoggedIn"
                :displayName="getUserDisplayName"
                :email="getUserEmail"
                v-show="!uiCartIconIsShowingOrderInfo"
              ></UserDropDownIcon>
            </div>
            <CartIcon v-if="bShowShoppingCartIcon" />
          </el-row>
        </el-row>
      </el-header>
      <Branding
          :school-name="oStorefront.theme.storefront_title"
          :logo="oStorefront.theme.template_logo"
          :logo-url="oStorefront.theme.template_logo_url"
          :logo-background-color="oStorefront.theme.setting_theme_logo_background_color"
          :description="oStorefront.theme.template_description"
          :show-school-name="oStorefront.theme.setting_theme_show_title"
          :show-logo="oStorefront.theme.setting_theme_show_logo"
          :show-description="oStorefront.theme.setting_theme_show_description && showBrandingDescription"
      ></Branding>
      <router-view></router-view>
      <footer class="el-footer" style="background-color: #f4f4f4">
        <Footer :darkText="true" style="margin: 40px 0" />
      </footer>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Footer from "@/components/layout/Footer.vue";
import StorefrontTitle from "./components/layout/StorefrontTitle";
import CartIcon from "./components/CartIcon";
import UserDropDownIcon from "./components/layout/UserDropDownIcon";
import Branding from "@/modules/shop/components/layout/Branding";
export default {
  components: {
    Branding,
    UserDropDownIcon,
    CartIcon,
    StorefrontTitle,
    Footer
  },
  data() {
    return {
      bLoading: true,
      bLoadError: false,
      bStorefrontNotFound: false,
      strStorefrontShortcode: ""
    };
  },
  props: {},
  computed: {
    // map store state to local computed properties:
    ...mapState({
      // id: state => state.book.id
    }),
    // map store getters to local computed properties:
    ...mapGetters([
      "getStorefront",
      "uiCartIconIsShowingOrderInfo",
      "userIsLoggedIn",
      "getUserDisplayName",
      "getUserEmail"
    ]),
    oStorefront() {
      return this.getStorefront || {
        theme: {}
      };
    },
    showBrandingDescription() {
      // only show the description/custom message on the homepage
      return this.$route.name === 'storefront';
    },
    bShowShoppingCartIcon() {
      let showCartIcon = false;
      // only show the cart icon if the route tells us we should
      if (this.$route.meta && this.$route.meta.showCartIcon === true) {
        showCartIcon = true;
      }
      return !this.bLoadError && showCartIcon;
    }
  },
  methods: {
    ...mapActions(["getStorefrontCatalog"]),
    onLogoClick() {
      this.$router.push({ name: "storefront" });
    },
    // This component acts as a parent to all other components in the storefront, housing
    // the main router view. Here, we fetch the storefront config, so we can
    // populate some UI components that depend on storefront branding.

    // It's worth noting that this API call is duplicated in
    // ShopView.vue, which actually uses the catalog data to display products.
    // The API call here should *really* call a separate
    // very lightweight API that just returns the bare minimum
    // needed to bootstrap the storefront.
    init: async function() {
      this.bLoadError = false;
      try {
        await this.getStorefrontCatalog(this.strStorefrontShortcode);
      } catch (err) {
        this.bLoadError = true;
      }
    }
  },
  mounted() {
    this.strStorefrontShortcode = this.$route.params.id;
    this.init();
  }
};
</script>
